var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"color":"black"}},[_c('Navbar',{key:`${_vm.$route.fullPath}-navbar`}),_c('v-main',{key:_vm.resized,class:_vm.main_class},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }